<template>
  <div>
    <div>
      <el-alert
        :title="language('promotionRules.discountTips')"
        :closable="false"
        class="alert"
      ></el-alert>

      <template v-if="radio == '1'">
        <el-form-item prop="activityRuleList">
          <div
            class="input_box"
            v-for="(items, index) in form.activityRuleList[0].activityRuleList"
          >
            <div class="input_list">
              <!-- <div>價格</div> -->
              <div>{{ language("promotionRules.price") }}</div>
              <el-input
                class="input"
                v-model="items.values"
                @input="changeDiscount3($event, index)"
              ></el-input>
            </div>
            <div class="input_list">
              <!-- <div>折扣</div> -->
              <div>{{ language("promotionRules.discount") }}</div>
              <el-input
                class="input"
                v-model="items.values2"
                @input="changeDiscount2($event, index)"
              ></el-input>
            </div>
            <el-button
              type="danger"
              icon="el-icon-delete"
              circle
              @click="dele(index)"
            ></el-button>
          </div>
        </el-form-item>
      </template>

      <div class="add">
        <el-button @click="add">Add</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import uploadUtils from "../../../utils/ossUtils";
export default {
  components: {},

  props: {
    formData: Object,
  },
  data() {
    return {
      radio: "1",
      form: {
        activityRuleList: [
          {
            activityRuleList: [
              {
                ruleCode: "reduce_full_discount",
                ruleName: "满xx元打xx折",
                values: "",
                values2: "",
                status: 0,
              },
            ],
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        let data = JSON.parse(JSON.stringify(this.form));
        for (
          let i = 0;
          i < data.activityRuleList[0].activityRuleList.length;
          i++
        ) {
          // let values =
          //   (data.activityRuleList[0].activityRuleList[i].values * 1000) / 10;
          let values = this.numMulti(
            data.activityRuleList[0].activityRuleList[i].values,
            100
          );
          let values2 = data.activityRuleList[0].activityRuleList[i].values2;
          if (values2) {
            data.activityRuleList[0].activityRuleList[i].values =
              values + "," + values2;
          } else {
            if (values2) {
              data.activityRuleList[0].activityRuleList[i].values = "";
            }
          }
        }

        this.$emit("change", data);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    add() {
      this.form.activityRuleList[0].activityRuleList.push({
        ruleCode: "reduce_full_discount",
        ruleName: "满xx元打xx折",
        values: "",
        values2: "",
        status: 0,
      });
    },
    dele(index) {
      this.form.activityRuleList[0].activityRuleList.splice(index, 1);
    },

    changeDiscount2(e, index) {
      if (e < 0 || e > 10 || isNaN(e)) {
        this.$alert(
          this.language("promotionRules.checkDiscountTips"),
          "折扣提示",
          {
            confirmButtonText: "確認",
            callback: (action) => {
              this.form.activityRuleList[0].activityRuleList[index].values2 =
                "";
            },
          }
        );
        return false;
      }
    },
    changeDiscount3(e, index) {
      if (e < 0 || isNaN(e)) {
        this.$alert("請輸入大於0的價格，請檢查價格!", "價格提示", {
          confirmButtonText: "確認",
          callback: (action) => {
            this.form.activityRuleList[0].activityRuleList[index].values = "";
          },
        });
        return false;
      }
    },

    //乘法
    numMulti(num1, num2) {
      var baseNum = 0;
      try {
        baseNum += num1.toString().split(".")[1].length;
      } catch (e) {}
      try {
        baseNum += num2.toString().split(".")[1].length;
      } catch (e) {}
      return (
        (Number(num1.toString().replace(".", "")) *
          Number(num2.toString().replace(".", ""))) /
        Math.pow(10, baseNum)
      );
    },
  },
  mounted() {
    if (this.formData.id && this.formData.activityType == "buyMoreGetMore") {
      let activityRuleList = JSON.parse(
        JSON.stringify(this.formData.activityRuleList)
      );
      for (let i = 0; i < activityRuleList[0].activityRuleList.length; i++) {
        let arr = activityRuleList[0].activityRuleList[i].values.split(",");
        // let values = (arr[0] / 1000) * 10;
        // let values = this.numDiv(arr[0], 100);
        let values = arr[0] / 100;
        let values2 = arr[1];
        activityRuleList[0].activityRuleList[i].values = values;
        activityRuleList[0].activityRuleList[i].values2 = values2;
      }
      this.form.activityRuleList = [...activityRuleList];
    }
  },
};
</script>
<style scoped>
.input_box {
  display: flex;
  margin-bottom: 20px;
}
.input_list {
  /* width: 200px; */
  display: flex;
  align-items: center;
  margin-right: 20px;
}
.input_list div {
  /* width: 50px; */
  font-size: 18px;
  font-weight: 600;
}
.input_list .input {
  margin-left: 8px;
  width: 200px;
}
.group {
  margin-bottom: 20px;
}
.add {
  margin-top: 10px;
}
.alert {
  width: 560px;
  padding: 10px 0;
  margin-bottom: 10px;
}
</style>